export default "__VITE_ASSET__D0JaTV2H__"